<template>
  <div class="satisfiaed">
    <!-- 满意结果反馈 -->
    <div class="result" v-show='!myshow'>
      <img src="../../assets/img/result_f.png" style="">
      <span style="">提交成功，感谢您的反馈。</span>  
    </div>
    <!-- 不满意结果反馈 -->
    <div class="result" v-show='!bmyshow'>
      <img src="../../assets/img/result_f.png" style="">
      <span style="">提交成功，我们会继续改进。</span>  
    </div>
    <div class="main">
      <div class="fl" style="color: #666666">您对搜索结果：</div>
      <div class="bumanyi fr" @click="bumanyi"><span>不满意</span></div>
      <div class="manyi fr" @click="manyi"><span>满意</span></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "v-silder-satisfiaed",
  components: {},
  props: {
    cList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    cKeyWord: { type: String },
  },
  data() {
    return {
      myshow:true,
      bmyshow:true,
    };
  },
  watch: {},
  computed: {
    // 从vuex中获取搜索记录
    Histoty() {
      return this.$store.state.searchHistory;
    },
  }, 
  methods: {
    async manyi() {
      const { data: res } = await this.$http.get(
        "/nmsearch/trssearch/satisfiedrange/save.do",
        {
          params: {
            sKeyword: this.cKeyWord,
            sUserSatisfied: 1,
          },
        }
      );
      if (res.code == 0) {
        console.log(this.cKeyWord);
        // alert("已提交您的评价，感谢您的认同！");
        this.myshow=!this.myshow;
      }
    },
    async bumanyi() {
      const { data: res } = await this.$http.get(
        // "/nmsearch/search/satisfiedrange/save.do",
        "/nmsearch/trssearch/satisfiedrange/save.do",
        {
          params: {
            sKeyword: this.cKeyWord,
            sUserSatisfied: 0,
          },
        }
      );
      if (res.code == 0) {
        // alert("已提交您的评价，我们会继续改进！");
        this.bmyshow=!this.bmyshow;
      }
    },
  },
  created() {
    // console.log(this.cList);
  },
  mounted() {},
};
</script>

<style lang='less' scoped>
.fl {
  float: left;
}
.fr {
  float: right;
}
.clear {
  clear: both;
}
.satisfiaed {
  // width: 323px;
  width:100%;
  height: 53px;
  background-image: url("../../assets/img/satisfiaed.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin-bottom: 40px;
  padding-top: 22px;
  box-shadow: #f0f0f0 0px 0px 10px;
  position: relative;

  .main {
    width: 290px;
    height: 30px;
    margin: 0 auto;
    .manyi {
      width: 68px;
      height: 31px;
      background-image: url("../../assets/img/manyi.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      margin-right: 20px;
      cursor: pointer;
      font-size: 14px;
      line-height: 31px;
      color: #ffffff;

      span {
        float: right;
        padding-right: 10px;
      }
    }
    .bumanyi {
      width: 87px;
      height: 31px;
      background-image: url("../../assets/img/bumanyi.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      cursor: pointer;
      font-size: 14px;
      line-height: 31px;
      color: #ffffff;

      span {
        float: right;
        padding-right: 10px;
      }
    }
  }

  .result{
    position:absolute;
    top:0;
    left:0;
    width:100%;
    height:70px;
    background:#fff;

    img{
      margin-left:40px;
      vertical-align:middle;
    }

    span{
      font-size:16px;
      color:#666666;
      margin-left:20px;
      line-height:73px;
    }
  }
}
</style>